import { useState, useEffect, useRef } from 'react';
import './App.css';

// ===== TRANSLATIONS =====
const T = {
  de: {
    nav: ['Über mich', 'Skills', 'Leistungen', 'Erfahrung', 'Kontakt', 'Impressum'],
    heroBadge: '🚀 OZ Digital Services Özdemir',
    heroTitle: 'IT-Spezialist & Freelancer · Langenfeld',
    heroSub: 'Fachinformatiker · Servicedesk · App-Entwicklung · IT-Support',
    heroCta1: 'Kontakt aufnehmen',
    heroCta2: 'Leistungen ansehen',
    aboutTitle: 'Über mich',
    aboutP1: 'Ich bin Serhat Özdemir – IT-Fachmann aus Langenfeld mit über <strong>20 Jahren Erfahrung</strong> in der Branche. Von Hardware-Reparatur über Netzwerktechnik bis hin zu modernem Helpdesk-Support bei einem internationalen Unternehmen.',
    aboutP2: 'Nach meiner erfolgreichen Umschulung zum <strong>Fachinformatiker Anwendungsentwicklung (IHK Köln, 2023)</strong> an der TASYS GmbH in Leverkusen habe ich mein Spektrum gezielt erweitert: Ich entwickle Apps und baue mit meinem Gewerbe <strong>OZ Digital Services</strong> digitale Produkte und Einkommensquellen auf.',
    aboutP3: 'Mein Ziel: Technisches Know-how mit unternehmerischem Denken verbinden – und langfristig eigene digitale Produkte skalieren.',
    stat1: 'Jahre IT-Erfahrung', stat2: 'Fachinformatiker', stat3: 'Sprachen', stat4: 'Lernbereitschaft',
    skillsTitle: 'Skills',
    servicesTitle: 'Leistungen',
    servicesSub: 'Was ich für dich tun kann – als Freelancer und Selbstständiger',
    expTitle: 'Berufliche Erfahrung',
    contactTitle: 'Kontakt',
    contactSub: 'Projekt, Anfrage oder einfach Hallo? Meld dich!',
    formSubject: 'Betreff',
    formName: 'Dein Name',
    formEmail: 'Deine E-Mail',
    formMsg: 'Deine Nachricht...',
    formSend: 'Nachricht senden ✉',
    formSending: 'Wird gesendet...',
    formSuccess: '✅ Nachricht gesendet! Ich melde mich bald.',
    formError: '❌ Fehler beim Senden. Bitte versuche es erneut.',
    impTitle: 'Impressum',
    privTitle: 'Datenschutzerklärung',
    impContent: `<h3>Angaben gemäß § 5 TMG / § 18 Abs. 2 MStV</h3>
<p>Serhat Özdemir<br/>OZ Digital Services Özdemir<br/>Am Wiesengrund 70<br/>40764 Langenfeld (Rheinland)</p>
<h3>Kontakt</h3>
<p>Telefon: 0178 5105003<br/>E-Mail: contact@serhat.oz-it.info<br/>Web: https://serhat.oz-it.info</p>
<h3>Berufsbezeichnung & Gewerbeanmeldung</h3>
<p>Berufsbezeichnung: Fachinformatiker für Anwendungsentwicklung (IHK Köln, 2023)<br/>
Gewerbeanmeldung: Stadt Langenfeld, Gemeindekennzahl 05158020<br/>
Beginn der Tätigkeit: 01.01.2026</p>
<h3>Umsatzsteuer</h3>
<p>Gemäß § 19 UStG wird keine Umsatzsteuer berechnet (Kleinunternehmerregelung). Es wird daher keine Umsatzsteuer-Identifikationsnummer ausgewiesen.</p>
<h3>Inhaltlich Verantwortlicher gemäß § 18 Abs. 2 MStV</h3>
<p>Serhat Özdemir, Am Wiesengrund 70, 40764 Langenfeld</p>
<h3>Haftung für Inhalte</h3>
<p>Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Bei bekannt werden von Rechtsverletzungen werde ich derartige Inhalte umgehend entfernen.</p>
<h3>Haftung für Links</h3>
<p>Mein Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
<h3>Urheberrecht</h3>
<p>Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors.</p>
<h3>Streitschlichtung</h3>
<p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer noopener">https://ec.europa.eu/consumers/odr/</a><br/>
Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>`,
    privContent: `<h3>1. Datenschutz auf einen Blick</h3>
<p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.</p>
<h3>2. Verantwortlicher</h3>
<p>Serhat Özdemir<br/>OZ Digital Services Özdemir<br/>Am Wiesengrund 70<br/>40764 Langenfeld<br/>E-Mail: contact@serhat.oz-it.info<br/>Tel.: 0178 5105003</p>
<h3>3. Datenerfassung auf dieser Website</h3>
<p><strong>Server-Log-Dateien:</strong> Der Hosting-Anbieter ALL-INKL.COM erhebt beim Aufruf dieser Website automatisch Informationen in sog. Server-Log-Dateien (IP-Adresse, Browser, Betriebssystem, Referrer-URL, Datum/Uhrzeit). Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren Betrieb).</p>
<p><strong>Kontaktformular:</strong> Bei Nutzung des Kontaktformulars werden Name, E-Mail-Adresse und Nachricht gespeichert, um Ihre Anfrage zu bearbeiten. Diese Daten werden nicht ohne Ihre Einwilligung weitergegeben. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.</p>
<p><strong>Cookies:</strong> Diese Website setzt keine Tracking-Cookies und verwendet keine Analyse-Dienste (kein Google Analytics, kein Facebook Pixel o.ä.).</p>
<h3>4. Hosting</h3>
<p>Diese Website wird bei ALL-INKL.COM, Neue Medien Münnich, Hauptstraße 68, 02742 Friedersdorf, Deutschland gehostet. Details: <a href="https://all-inkl.com/datenschutzinformationen/" target="_blank" rel="noreferrer noopener">all-inkl.com/datenschutzinformationen</a>. Es besteht ein Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO.</p>
<h3>5. Google Fonts</h3>
<p>Diese Website lädt Schriftarten (Syne, DM Sans) von Google Fonts (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland). Dabei wird Ihre IP-Adresse an Google übertragen. Um dies zu vermeiden, wurden die Fonts als @import-Direktive eingebunden – Google erhält bei jedem Seitenaufruf Ihre IP-Adresse. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO. Sie können die Schriftarten in Ihrem Browser blockieren.</p>
<h3>6. Ihre Rechte (Art. 15–22 DSGVO)</h3>
<p>Sie haben jederzeit das Recht auf: Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21). Wenden Sie sich an: contact@serhat.oz-it.info</p>
<p>Beschwerderecht: Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren. Zuständig für NRW: Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, Postfach 20 04 44, 40102 Düsseldorf.</p>`,
    location: 'Langenfeld, NRW',
  },
  en: {
    nav: ['About', 'Skills', 'Services', 'Experience', 'Contact', 'Imprint'],
    heroBadge: '🚀 OZ Digital Services Özdemir',
    heroTitle: 'IT Specialist & Freelancer · Langenfeld',
    heroSub: 'IT Specialist · Service Desk · App Development · IT Support',
    heroCta1: 'Get in touch',
    heroCta2: 'View services',
    aboutTitle: 'About me',
    aboutP1: 'I\'m Serhat Özdemir – IT professional from Langenfeld with over <strong>20 years of experience</strong> in the industry. From hardware repair and networking to modern helpdesk support for international companies.',
    aboutP2: 'After completing my retraining as a <strong>IT Application Developer (IHK Cologne, 2023)</strong> at TASYS GmbH in Leverkusen, I expanded my scope: I develop apps and build digital products through my business <strong>OZ Digital Services</strong>.',
    aboutP3: 'My goal: Combine technical expertise with entrepreneurial thinking – and scale my own digital products long-term.',
    stat1: 'Years IT Experience', stat2: 'IT Specialist', stat3: 'Languages', stat4: 'Always Learning',
    skillsTitle: 'Skills',
    servicesTitle: 'Services',
    servicesSub: 'What I can do for you – as a freelancer and independent professional',
    expTitle: 'Professional Experience',
    contactTitle: 'Contact',
    contactSub: 'Project, inquiry or just a hello? Reach out!',
    formSubject: 'Subject',
    formName: 'Your Name',
    formEmail: 'Your Email',
    formMsg: 'Your message...',
    formSend: 'Send message ✉',
    formSending: 'Sending...',
    formSuccess: '✅ Message sent! I\'ll get back to you soon.',
    formError: '❌ Error sending. Please try again.',
    impTitle: 'Legal Notice',
    privTitle: 'Privacy Policy',
    privContent: `<h3>1. Overview</h3>
<p>The following information provides a simple overview of what happens to your personal data when you visit this website.</p>
<h3>2. Controller</h3>
<p>Serhat Özdemir<br/>OZ Digital Services Özdemir<br/>Am Wiesengrund 70<br/>40764 Langenfeld, Germany<br/>Email: contact@serhat.oz-it.info<br/>Phone: +49 178 5105003</p>
<h3>3. Data collection on this website</h3>
<p><strong>Server log files:</strong> The hosting provider ALL-INKL.COM automatically collects information in server log files (IP address, browser, OS, referrer URL, date/time). This data is not merged with other data sources. Legal basis: Art. 6(1)(f) GDPR.</p>
<p><strong>Contact form:</strong> When using the contact form, your name, email address and message are stored to process your inquiry. This data will not be shared without your consent. Legal basis: Art. 6(1)(b) GDPR.</p>
<p><strong>Cookies:</strong> This website does not use tracking cookies or analytics services.</p>
<h3>4. Hosting</h3>
<p>This website is hosted by ALL-INKL.COM, Germany. Details: <a href="https://all-inkl.com/datenschutzinformationen/" target="_blank" rel="noreferrer noopener">all-inkl.com/datenschutzinformationen</a></p>
<h3>5. Google Fonts</h3>
<p>This website loads fonts from Google Fonts (Google Ireland Limited). Your IP address is transmitted to Google when loading fonts. Legal basis: Art. 6(1)(f) GDPR.</p>
<h3>6. Your rights (Art. 15–22 GDPR)</h3>
<p>You have the right to: access (Art. 15), rectification (Art. 16), erasure (Art. 17), restriction (Art. 18), data portability (Art. 20) and objection (Art. 21). Contact: contact@serhat.oz-it.info</p>`,
    impContent: `<h3>Information pursuant to § 5 TMG</h3>
<p>Serhat Özdemir<br/>OZ Digital Services<br/>Am Wiesengrund 70<br/>40764 Langenfeld, Germany</p>
<h3>Contact</h3>
<p>Phone: 0178 5105003<br/>Email: contact@serhat.oz-it.info</p>
<h3>Business Registration</h3>

<h3>Liability Disclaimer</h3>
<p>The content of this website has been created with the utmost care. No guarantee is given for the accuracy, completeness, and timeliness of the content.</p>
<h3>Privacy Policy</h3>
<p>This website does not collect personal data, except when you voluntarily contact us via the form. Your data is used solely to process your request and is not shared with third parties. You have the right to access, rectify and delete your stored data at any time (Art. 15–17 GDPR). No cookies or tracking services are used.</p>`,
    location: 'Langenfeld, NRW',
  },
  tr: {
    nav: ['Hakkımda', 'Yetenekler', 'Hizmetler', 'Deneyim', 'İletişim', 'Künye'],
    heroBadge: '🚀 OZ Digital Services Özdemir',
    heroTitle: 'BT Uzmanı & Freelancer · Langenfeld',
    heroSub: 'BT Uzmanı · Servis Masası · Uygulama Geliştirme · BT Destek',
    heroCta1: 'İletişime geç',
    heroCta2: 'Hizmetleri gör',
    aboutTitle: 'Hakkımda',
    aboutP1: 'Ben Serhat Özdemir – Langenfeld\'den <strong>20 yılı aşkın deneyime</strong> sahip bir BT uzmanıyım. Donanım tamirinden ağ teknolojilerine, uluslararası şirketler için modern yardım masası desteğine kadar geniş bir yelpazede hizmet sunuyorum.',
    aboutP2: '<strong>Fachinformatiker Anwendungsentwicklung (IHK Köln, 2023)</strong> yeniden eğitimimi Leverkusen\'deki TASYS GmbH\'de tamamladıktan sonra kapsamımı genişlettim: <strong>OZ Digital Services</strong> işletmem aracılığıyla uygulama geliştiriyor ve dijital ürünler oluşturuyorum.',
    aboutP3: 'Hedefim: Teknik bilgiyi girişimci düşünceyle birleştirmek ve uzun vadede kendi dijital ürünlerimi büyütmek.',
    stat1: 'Yıl BT Deneyimi', stat2: 'BT Uzmanı', stat3: 'Dil', stat4: 'Öğrenmeye Açık',
    skillsTitle: 'Yetenekler',
    servicesTitle: 'Hizmetler',
    servicesSub: 'Freelancer olarak sizin için yapabileceklerim',
    expTitle: 'Mesleki Deneyim',
    contactTitle: 'İletişim',
    contactSub: 'Proje, soru veya merhaba demek için yazın!',
    formSubject: 'Konu',
    formName: 'Adınız',
    formEmail: 'E-posta adresiniz',
    formMsg: 'Mesajınız...',
    formSend: 'Mesaj gönder ✉',
    formSending: 'Gönderiliyor...',
    formSuccess: '✅ Mesaj gönderildi! En kısa sürede dönüş yapacağım.',
    formError: '❌ Gönderme hatası. Lütfen tekrar deneyin.',
    impTitle: 'Künye',
    privTitle: 'Gizlilik Politikası',
    privContent: `<h3>1. Genel Bakış</h3>
<p>Bu web sitesini ziyaret ettiğinizde kişisel verilerinizle ne yapıldığına dair basit bir genel bakış.</p>
<h3>2. Sorumlu Kişi</h3>
<p>Serhat Özdemir<br/>OZ Digital Services Özdemir<br/>Am Wiesengrund 70<br/>40764 Langenfeld, Almanya<br/>E-posta: contact@serhat.oz-it.info</p>
<h3>3. Kişisel Veri Toplama</h3>
<p><strong>Sunucu günlükleri:</strong> ALL-INKL.COM otomatik olarak sunucu günlük dosyalarında bilgi toplar (IP adresi, tarayıcı, işletim sistemi vb.). Yasal dayanak: GDPR Madde 6(1)(f).</p>
<p><strong>İletişim formu:</strong> İletişim formu kullanıldığında adınız, e-posta adresiniz ve mesajınız saklanır. Bu veriler izniniz olmadan paylaşılmaz. Yasal dayanak: GDPR Madde 6(1)(b).</p>
<p><strong>Çerezler:</strong> Bu web sitesi izleme çerezleri veya analiz hizmetleri kullanmaz.</p>
<h3>4. Haklarınız</h3>
<p>Erişim, düzeltme, silme ve itiraz haklarınız için: contact@serhat.oz-it.info</p>`,
    impContent: `<h3>§ 5 TMG uyarınca bilgiler</h3>
<p>Serhat Özdemir<br/>OZ Digital Services<br/>Am Wiesengrund 70<br/>40764 Langenfeld, Almanya</p>
<h3>İletişim</h3>
<p>Telefon: 0178 5105003<br/>E-posta: contact@serhat.oz-it.info</p>
<h3>Ticari Kayıt</h3>

<h3>Gizlilik Politikası</h3>
<p>Bu web sitesi, iletişim formu aracılığıyla gönüllü iletişim dışında kişisel veri toplamamaktadır. Verileriniz yalnızca talebinizi işlemek için kullanılır ve üçüncü taraflarla paylaşılmaz. Çerez veya izleme hizmetleri kullanılmamaktadır.</p>`,
    location: 'Langenfeld, NRW',
  }
};

const SKILLS = [
  { name: { de: 'Windows & Active Directory', en: 'Windows & Active Directory', tr: 'Windows & Active Directory' }, level: 90, cat: 'System' },
  { name: { de: 'Microsoft 365 / Teams', en: 'Microsoft 365 / Teams', tr: 'Microsoft 365 / Teams' }, level: 85, cat: 'System' },
  { name: { de: 'PC-Aufbau & Reparatur', en: 'PC Build & Repair', tr: 'PC Montaj & Onarım' }, level: 95, cat: 'Hardware' },
  { name: { de: 'Netzwerktechnik', en: 'Networking', tr: 'Ağ Teknolojisi' }, level: 80, cat: 'Hardware' },
  { name: { de: 'Remote Support', en: 'Remote Support', tr: 'Uzaktan Destek' }, level: 90, cat: 'Support' },
  { name: { de: 'HTML / CSS / JavaScript', en: 'HTML / CSS / JavaScript', tr: 'HTML / CSS / JavaScript' }, level: 65, cat: 'Dev' },
  { name: { de: 'C# Grundlagen', en: 'C# Basics', tr: 'C# Temelleri' }, level: 50, cat: 'Dev' },
  { name: { de: 'App-Entwicklung', en: 'App Development', tr: 'Uygulama Geliştirme' }, level: 55, cat: 'Dev' },
];

const SERVICES_DATA = [
  { icon: '🖥️', title: { de: 'IT-Support & Helpdesk', en: 'IT Support & Helpdesk', tr: 'BT Destek & Yardım Masası' }, desc: { de: 'First- und Second-Level-Support, Fehleranalyse, Ticketbearbeitung – remote und vor Ort.', en: 'First and second level support, error analysis, ticket processing – remote and on-site.', tr: 'Birinci ve ikinci seviye destek, hata analizi, bilet işleme – uzaktan ve yerinde.' } },
  { icon: '🔧', title: { de: 'PC-Service & Reparatur', en: 'PC Service & Repair', tr: 'PC Servis & Onarım' }, desc: { de: 'Aufbau, Reparatur und Optimierung von Desktop-PCs und Laptops. Neuinstallation von Betriebssystemen.', en: 'Assembly, repair and optimization of desktop PCs and laptops. OS reinstallation.', tr: 'Masaüstü bilgisayar ve dizüstü bilgisayarların montajı, onarımı ve optimizasyonu.' } },
  { icon: '🌐', title: { de: 'Netzwerk & Administration', en: 'Network & Administration', tr: 'Ağ & Yönetim' }, desc: { de: 'Einrichtung kleiner Netzwerke, WLAN-Optimierung, Active Directory, Benutzerverwaltung.', en: 'Setup of small networks, WiFi optimization, Active Directory, user management.', tr: 'Küçük ağların kurulumu, Wi-Fi optimizasyonu, Active Directory, kullanıcı yönetimi.' } },
  { icon: '📱', title: { de: 'App-Entwicklung', en: 'App Development', tr: 'Uygulama Geliştirme' }, desc: { de: 'Planung, Umsetzung und Entwicklung von Apps.', en: 'Planning, implementation and development of apps.', tr: 'Uygulamaların planlanması, uygulanması ve geliştirilmesi.' } },
];

const EXPERIENCE_DATA = [
  { period: { de: 'seit 01/2026', en: 'since 01/2026', tr: "01/2026'dan beri" }, company: 'OZ Digital Services', role: { de: 'IT-Freelancer & Selbstständiger', en: 'IT Freelancer & Self-employed', tr: 'BT Freelancer & Serbest Çalışan' }, desc: { de: 'IT-Spezialist & Freelancer · Fachinformatiker · App-Entwicklung · IT-Support. Langenfeld (Rheinland), NRW · Hybrid.', en: 'IT Specialist & Freelancer · App Development · IT Support. Langenfeld, NRW · Hybrid.', tr: 'BT Uzmanı & Freelancer · Uygulama Geliştirme · BT Destek. Langenfeld, NRW · Hibrit.' }, current: true },
  { period: { de: 'seit 03/2024', en: 'since 03/2024', tr: "03/2024'ten beri" }, company: 'Cancom GmbH', role: { de: 'Servicedesk Specialist', en: 'Servicedesk Specialist', tr: 'Servis Masası Uzmanı' }, desc: { de: 'First- & Second-Level-Support für ein internationales Unternehmen. Windows, M365, Active Directory, Remotezugriff.', en: 'First & second level support for an international company. Windows, M365, Active Directory, remote access.', tr: 'Uluslararası bir şirket için birinci ve ikinci seviye destek. Windows, M365, Active Directory, uzaktan erişim.' }, current: true },
  { period: { de: '2023', en: '2023', tr: '2023' }, company: 'PERK Innovation GmbH', role: { de: 'Junior Softwareentwickler', en: 'Junior Software Developer', tr: 'Junior Yazılım Geliştirici' }, desc: { de: 'Anwendungsentwicklung nach abgeschlossener Umschulung.', en: 'Application development after completed retraining.', tr: 'Yeniden eğitim tamamlandıktan sonra uygulama geliştirme.' }, current: false },
  { period: { de: '2020–2023', en: '2020–2023', tr: '2020–2023' }, company: 'TASYS GmbH, Leverkusen', role: { de: 'Umschulung: Fachinformatiker Anwendungsentwicklung (IHK Köln)', en: 'Retraining: IT Application Developer (IHK Cologne)', tr: 'Yeniden Eğitim: BT Uygulama Geliştirici (IHK Köln)' }, desc: { de: 'Staatlich anerkannter Abschluss. Schwerpunkt: Softwareprojekte, Algorithmen, IT-Infrastruktur, C#, HTML/CSS/JS.', en: 'State-recognized qualification. Focus: software projects, algorithms, IT infrastructure, C#, HTML/CSS/JS.', tr: 'Devlet tarafından tanınan nitelik. Odak: yazılım projeleri, algoritmalar, BT altyapısı, C#, HTML/CSS/JS.' }, current: false },
  { period: { de: '2003–2009', en: '2003–2009', tr: '2003–2009' }, company: 'BCS – Büro Computer Systeme', role: { de: 'Mitgründer & Geschäftsführer (GbR)', en: 'Co-Founder & Managing Director', tr: 'Kurucu Ortak & Genel Müdür' }, desc: { de: 'Groß- & Einzelhandel EDV-Artikel, Hardware-Aufbau, Netzwerktechnik, Kundensupport in Neuss.', en: 'Wholesale & retail of IT products, hardware assembly, networking, customer support in Neuss.', tr: 'Neuss\'ta BT ürünleri toptan ve perakende satışı, donanım montajı, ağ teknolojisi, müşteri desteği.' }, current: false },
  { period: { de: '2001–2002', en: '2001–2002', tr: '2001–2002' }, company: 'A.I.T. Essen', role: { de: 'EDV-Service-Techniker', en: 'IT Service Technician', tr: 'BT Servis Teknisyeni' }, desc: { de: 'Berufsbegleitender Lehrgang. Grundlagen Hardwareservice und IT-Systeme.', en: 'Part-time course. Hardware service basics and IT systems.', tr: 'Yarı zamanlı kurs. Donanım servisi temelleri ve BT sistemleri.' }, current: false },
];

function useInView() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}

function SkillBar({ name, level, cat, delay, lang }) {
  const [ref, inView] = useInView();
  return (
    <div ref={ref} className="skill-item">
      <div className="skill-header">
        <span className="skill-name">{name[lang]}</span>
        <span className="skill-cat">{cat}</span>
      </div>
      <div className="skill-track">
        <div className="skill-fill" style={{ width: inView ? level + '%' : '0%', transitionDelay: delay + 'ms' }} />
      </div>
    </div>
  );
}

export default function App() {
  const [lang, setLang] = useState('de');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showImp, setShowImp] = useState(false);
  const [showPriv, setShowPriv] = useState(false);
  const [formState, setFormState] = useState({ name: '', email: '', subject: '', message: '' });
  const [formStatus, setFormStatus] = useState('idle'); // idle | sending | success | error
  const t = T[lang];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const sectionIds = ['uber-mich', 'skills', 'leistungen', 'erfahrung', 'kontakt'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');
    try {
      const fd = new FormData();
      fd.append('name', formState.name);
      fd.append('email', formState.email);
      fd.append('subject', formState.subject);
      fd.append('message', formState.message);
      const res = await fetch('./contact.php', { method: 'POST', body: fd });
      if (res.ok) {
        setFormStatus('success');
        setFormState({ name: '', email: '', subject: '', message: '' });
      } else { setFormStatus('error'); }
    } catch { setFormStatus('error'); }
    setTimeout(() => setFormStatus('idle'), 5000);
  };

  return (
    <div className="app">
      {/* NAV */}
      <nav className={'nav' + (scrolled ? ' nav--scrolled' : '')}>
        <div className="nav-logo" onClick={() => scrollTo('hero')}>
          <span className="logo-oz">OZ</span><span className="logo-it"> Digital</span>
        </div>
        <div className="nav-right">
          <div className="lang-switcher">
            {['de','en','tr'].map(l => (
              <button key={l} className={'lang-btn' + (lang === l ? ' active' : '')} onClick={() => setLang(l)}>
                {l === 'de' ? '🇩🇪' : l === 'en' ? '🇬🇧' : '🇹🇷'} {l.toUpperCase()}
              </button>
            ))}
          </div>
          <button className={'burger' + (menuOpen ? ' open' : '')} onClick={() => setMenuOpen(o => !o)}>
            <span /><span /><span />
          </button>
        </div>
        <ul className={'nav-links' + (menuOpen ? ' open' : '')}>
          {t.nav.slice(0, 5).map((label, i) => (
            <li key={i}><button onClick={() => scrollTo(sectionIds[i])}>{label}</button></li>
          ))}
          <li><button onClick={() => { setShowImp(true); setMenuOpen(false); }}>{t.nav[5]}</button></li>
        </ul>
      </nav>

      {/* HERO */}
      <section id="hero" className="hero">
        <div className="hero-bg"><div className="hero-grid" /><div className="hero-glow" /></div>
        <div className="hero-content">
          <div className="hero-badge">{t.heroBadge}</div>
          <h1 className="hero-name">
            <span className="hero-first">Serhat</span>
            <span className="hero-last">Özdemir</span>
          </h1>
          <p className="hero-title">{t.heroTitle}</p>
          <p className="hero-sub">{t.heroSub}</p>
          <div className="hero-ctas">
            <button className="btn btn--primary" onClick={() => scrollTo('kontakt')}>{t.heroCta1}</button>
            <button className="btn btn--ghost" onClick={() => scrollTo('leistungen')}>{t.heroCta2}</button>
          </div>
          <div className="hero-links">
            <a href="mailto:contact@serhat.oz-it.info" className="hero-link">✉ contact@serhat.oz-it.info</a>
            <a href="tel:+4917851050030" className="hero-link">📞 0178 5105003</a>
            <a href="https://www.linkedin.com/in/serhat-%C3%B6zdemir-a4331054" target="_blank" rel="noreferrer" className="hero-link">in LinkedIn</a>
          </div>
        </div>
        <div className="hero-scroll" onClick={() => scrollTo('uber-mich')}>↓</div>
      </section>

      {/* ÜBER MICH */}
      <section id="uber-mich" className="section about">
        <div className="container">
          <h2 className="section-title">{t.aboutTitle}</h2>
          <div className="about-grid">
            <div className="about-text">
              <p dangerouslySetInnerHTML={{ __html: t.aboutP1 }} />
              <p dangerouslySetInnerHTML={{ __html: t.aboutP2 }} />
              <p dangerouslySetInnerHTML={{ __html: t.aboutP3 }} />
            </div>
            <div className="about-stats">
              <div className="stat"><span className="stat-num">20+</span><span className="stat-label">{t.stat1}</span></div>
              <div className="stat"><span className="stat-num">IHK</span><span className="stat-label">{t.stat2}</span></div>
              <div className="stat"><span className="stat-num">3</span><span className="stat-label">{t.stat3}</span></div>
              <div className="stat"><span className="stat-num">∞</span><span className="stat-label">{t.stat4}</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* SKILLS */}
      <section id="skills" className="section skills-section">
        <div className="container">
          <h2 className="section-title">{t.skillsTitle}</h2>
          <div className="skills-grid">
            {SKILLS.map((s, i) => <SkillBar key={i} {...s} delay={i * 70} lang={lang} />)}
          </div>
        </div>
      </section>

      {/* LEISTUNGEN */}
      <section id="leistungen" className="section services">
        <div className="container">
          <h2 className="section-title">{t.servicesTitle}</h2>
          <p className="section-sub">{t.servicesSub}</p>
          <div className="services-grid">
            {SERVICES_DATA.map((s, i) => (
              <div key={i} className="service-card">
                <div className="service-icon">{s.icon}</div>
                <h3 className="service-title">{s.title[lang]}</h3>
                <p className="service-desc">{s.desc[lang]}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ERFAHRUNG */}
      <section id="erfahrung" className="section experience">
        <div className="container">
          <h2 className="section-title">{t.expTitle}</h2>
          <div className="timeline">
            {EXPERIENCE_DATA.map((e, i) => (
              <div key={i} className={'timeline-item' + (e.current ? ' timeline-item--current' : '')}>
                <div className="timeline-dot" />
                <div className="timeline-body">
                  <span className="timeline-period">{typeof e.period === 'object' ? e.period[lang] : e.period}</span>
                  <h3 className="timeline-company">{e.company}</h3>
                  <p className="timeline-role">{e.role[lang]}</p>
                  <p className="timeline-desc">{e.desc[lang]}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* KONTAKT */}
      <section id="kontakt" className="section contact">
        <div className="container">
          <h2 className="section-title">{t.contactTitle}</h2>
          <p className="section-sub">{t.contactSub}</p>
          <div className="contact-grid">
            <div className="contact-info">
              <a href="mailto:contact@serhat.oz-it.info" className="contact-item">
                <span className="contact-icon">✉️</span><span>contact@serhat.oz-it.info</span>
              </a>
              <a href="tel:+4917851050030" className="contact-item">
                <span className="contact-icon">📞</span><span>0178 5105003</span>
              </a>
              <a href="https://www.linkedin.com/in/serhat-%C3%B6zdemir-a4331054" target="_blank" rel="noreferrer" className="contact-item">
                <span className="contact-icon">💼</span><span>LinkedIn</span>
              </a>
              <div className="contact-item">
                <span className="contact-icon">📍</span><span>{t.location}</span>
              </div>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <input value={formState.name} onChange={e => setFormState(s => ({...s, name: e.target.value}))} placeholder={t.formName} required className="form-input" />
              <input type="email" value={formState.email} onChange={e => setFormState(s => ({...s, email: e.target.value}))} placeholder={t.formEmail} required className="form-input" />
              <input value={formState.subject} onChange={e => setFormState(s => ({...s, subject: e.target.value}))} placeholder={t.formSubject} required className="form-input" />
              <textarea value={formState.message} onChange={e => setFormState(s => ({...s, message: e.target.value}))} placeholder={t.formMsg} rows={5} required className="form-input form-textarea" />
              <button type="submit" className="btn btn--primary" disabled={formStatus === 'sending'}>
                {formStatus === 'sending' ? t.formSending : t.formSend}
              </button>
              {formStatus === 'success' && <p className="form-feedback form-feedback--ok">{t.formSuccess}</p>}
              {formStatus === 'error' && <p className="form-feedback form-feedback--err">{t.formError}</p>}
            </form>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container footer-inner">
          <span><span className="logo-oz">OZ</span><span className="logo-it"> Digital Services</span> · Serhat Özdemir · Langenfeld</span>
          <span className="footer-right">
            <button className="footer-imp-btn" onClick={() => setShowImp(true)}>{t.impTitle}</button>
            <span className="footer-sep"> · </span>
            <button className="footer-imp-btn" onClick={() => setShowPriv(true)}>{t.privTitle}</button>
            &nbsp;·&nbsp; © {new Date().getFullYear()}
          </span>
        </div>
      </footer>

      {/* IMPRESSUM MODAL */}
      {showImp && (
        <div className="modal-overlay" onClick={() => setShowImp(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowImp(false)}>✕</button>
            <h2 className="modal-title">{t.impTitle}</h2>
            <div className="modal-body" dangerouslySetInnerHTML={{ __html: t.impContent }} />
          </div>
        </div>
      )}
      {showPriv && (
        <div className="modal-overlay" onClick={() => setShowPriv(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowPriv(false)}>✕</button>
            <h2 className="modal-title">{t.privTitle}</h2>
            <div className="modal-body" dangerouslySetInnerHTML={{ __html: t.privContent }} />
          </div>
        </div>
      )}
    </div>
  );
}
